import React from "react";
import { motion } from "framer-motion";
import { WrenchIcon } from "lucide-react";
import { CHECKOUT_URL } from "./constants";
interface CtaButtonProps {
  label: string;
  className?: string;
  showIcon?: boolean;
}
export function CtaButton({
  label,
  className = "",
  showIcon = true
}: CtaButtonProps) {
  return <motion.a href={CHECKOUT_URL} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} animate={{
    boxShadow: ["0 10px 30px -10px rgba(245,184,0,0.5)", "0 14px 40px -8px rgba(245,184,0,0.75)", "0 10px 30px -10px rgba(245,184,0,0.5)"]
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: "easeInOut"
    }
  }} className={`group inline-flex w-full items-center justify-center gap-2 rounded-xl bg-amber-400 px-5 py-4 text-center font-display text-base font-extrabold uppercase leading-tight tracking-tight text-neutral-900 sm:text-lg ${className}`} data-id="element-50" data-mp="cjzqa3xztr99">
      {showIcon && <WrenchIcon className="h-5 w-5 shrink-0 transition-transform group-hover:-rotate-12" data-id="element-51" data-mp="35yhay8mpzg7u" />}
      <span data-id="element-52" data-mp="39zj2026hglyq">{label}</span>
    </motion.a>;
}
interface TransformButtonProps {
  label: string;
  className?: string;
}

/** Softer "transformational" secondary CTA used under every section */
export function TransformButton({
  label,
  className = ""
}: TransformButtonProps) {
  return <motion.a href={CHECKOUT_URL} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex w-full max-w-md items-center justify-center gap-2 rounded-xl border-2 border-amber-400/70 bg-amber-400/10 px-5 py-3.5 text-center font-display text-sm font-bold uppercase tracking-tight text-amber-300 transition-colors hover:bg-amber-400 hover:text-neutral-900 sm:text-base ${className}`} data-id="element-53" data-mp="3ouz0qki0d61g">
      {label}
    </motion.a>;
}